import { render } from "./TotalValueLocked.vue?vue&type=template&id=19939286"
import script from "./TotalValueLocked.vue?vue&type=script&lang=js"
export * from "./TotalValueLocked.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__